module.exports = __webpack_public_path__ + "static/img/qi_9.adbe0fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qi_9.jpg
// module id = zRfs
// module chunks = 1